import { css } from '@emotion/css';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { getQueryParam } from 'src/lib/utils';
import { ReactComponent as Img } from '../../assets/images/img_image_tutorial_02.svg';
import { BackButton } from '../shared/buttons/BackButton';
import { RoundedButton } from '../shared/buttons/RoundedButton';
import { reveal } from '../shared/keyframe-animations';

const WalkthroughSecondStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 0 7vh;
  z-index: 1;

  h1,
  .image,
  .desc,
  .button {
    opacity: 0;
    animation: 0.4s ease-in-out ${reveal} both;
    @media (prefers-reduced-motion: reduce) {
      animation-delay: -1ms !important;
      animation-duration: 1ms;
      animation-iteration-count: 1;
    }
  }
  header {
    display: flex;
    align-items: center;
    width: 100%;
    height: 52px;
    padding: 0 4px;
  }
  h1 {
    font-size: calc(2vh + 8px);
    padding: 0 24px;
    transform: translateY(4px);
    animation-delay: 0.2s;
  }
  .space {
    flex: 1 1 auto;
  }
  .image {
    width: 90%;
    max-width: 360px;
    padding: 12px 36px;
    transform: translateY(4px);
    animation-delay: 0.4s;
  }
  .desc {
    margin: 0 24px;
    transform: translateY(4px);
    animation-delay: 0.8s;
    z-index: 1;
  }
  .button {
    width: 100%;
    padding: 0 24px;
    visibility: hidden;
    z-index: 1;
    animation-delay: 1s;
  }
  @media (max-width: 370px) {
    .desc {
      font-size: 14px;
    }
  }
`;

export const WalkthroughSecond: React.FC = () => {
  const { t } = useTranslation('translation');
  const history = useHistory();
  const location = useLocation();
  const raid = getQueryParam(location.search, 'raid');
  const handleButtonClick = useCallback(() => {
    const dest = raid ? `/deep-link/promotion/${raid}` : '/players/home';
    history.replace(dest);
  }, [history, raid]);
  const handleBackButton = useCallback(() => {
    const dest = raid ? `/walkthrough/1?raid=${raid}` : '/walkthrough/1';
    history.replace(dest);
  }, [history, raid]);

  return (
    <section className={WalkthroughSecondStyles}>
      <header>
        <BackButton ariaLabel={t('aria_button_back_to_previous')} onClick={handleBackButton} />
      </header>
      <h1>{t('tutorial_02')}</h1>
      <div className="image" aria-hidden={true}>
        <Img />
      </div>
      <p className="desc">{t('tutorial_03')}</p>
      <div className="space" />
      <div className="button">
        <RoundedButton color="white" background="#14c5b6" onClick={handleButtonClick}>
          {t('tutorial_04')}
        </RoundedButton>
      </div>
    </section>
  );
};
